
import { actionType } from "../nonSubscriber/action";
import { put, takeEvery } from 'redux-saga/effects';
import pageData from "../../assets/lang/jp/non-subscriber-page";
import { config } from "../../config";

function* fetchNonSubscribePageData() {  
  
  let pgData = {
    data: pageData.data
  };
  
  if(config.env !=='localhost') {
    pgData.data  = {...pageData.data ,...pageData[config.env]} 
  }  
  
  yield put({ type: actionType.GET_NON_SUBSCRIBER_RECEIVED, payload: pgData });
}

 

function* fetchErrorPageData() {  
  
  let pgData = {
    data: pageData.data
  };
  
  if(config.env !=='localhost') {
    pgData.data  = {...pageData.data ,...pageData[config.env]} 
  }  
  
  yield put({ type: actionType.GET_NON_SUBSCRIBER_RECEIVED, payload: pgData });
}
export const NonSubscriberSagas = [
  takeEvery(actionType.GET_NON_SUBSCRIBER_REQUEST, fetchNonSubscribePageData),
  takeEvery(actionType.GET_ERROR_PAGE_REQUEST, fetchErrorPageData)
]